import { render } from "./setting.vue?vue&type=template&id=332db782&scoped=true"
import script from "./setting.vue?vue&type=script&lang=js"
export * from "./setting.vue?vue&type=script&lang=js"

import "./setting.vue?vue&type=style&index=0&id=332db782&lang=scss"
import "./setting.vue?vue&type=style&index=1&id=332db782&lang=scss&scoped=true"

import exportComponent from "/Users/arvindersingh/Desktop/projects/parsoftwares/rt-backend/backend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-332db782"]])

export default __exports__